(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._navBar_kzibd_1{--swui-navbar-background-color: var(--lhds-color-ui-50);--swui-navbar-item-background-color-hover: var(--lhds-color-blue-700);--swui-navbar-item-background-color-selected: var(--lhds-color-blue-600);--swui-navbar-item-background-color-selected-hover: var( --lhds-color-blue-700 );--swui-nav-bar-height: 48px;background-color:var(--swui-navbar-background-color);height:var(--swui-nav-bar-height);min-height:var(--swui-nav-bar-height)}._navBarButton_b3x3w_1:hover{background:var(--lhds-color-ui-100)}._navBarButton_b3x3w_1:focus-visible{background:var(--lhds-color-ui-200)}._navBarButton_b3x3w_1:active{background:var(--lhds-color-ui-200)}._navBarButton_b3x3w_1._selected_b3x3w_14{background:var(--lhds-color-blue-200)}._navBarButton_b3x3w_1._selected_b3x3w_14:hover{background:var(--lhds-color-blue-100)}._navBarButton_b3x3w_1._selected_b3x3w_14:focus-visible{background:var(--lhds-color-blue-300)}._navBarButton_b3x3w_1._selected_b3x3w_14:active{background:var(--lhds-color-blue-200)}._navBarNotificationButton_1wt3y_1{--current-background-color: var(--lhds-color-ui-400);--current-outline-color: var(--modern-blue);background-color:var(--current-background-color);border-color:transparent;color:var(--lhds-color-ui-50);--swui-nav-bar-notification-shake-count: 3;transition:.5s width}._navBarNotificationButton_1wt3y_1:hover{--current-background-color: var(--lhds-color-red-500);--current-outline-color: var(--lhds-color-red-500)}._navBarNotificationButton_1wt3y_1:active{--current-background-color: var(--lhds-color-red-600);--current-outline-color: var(--lhds-color-red-600)}._navBarNotificationButton_1wt3y_1._unread_1wt3y_23 ._icon_1wt3y_23{transform-origin:top center;animation:_shake_1wt3y_1 1.5s ease-in-out var(--swui-nav-bar-notification-shake-count)}._navBarNotificationButton_1wt3y_1._unread_1wt3y_23{--current-background-color: var(--lhds-color-red-500);--current-outline-color: var(--lhds-color-red-500)}._navBarNotificationButton_1wt3y_1._unread_1wt3y_23:hover{--current-background-color: var(--lhds-color-red-600);--current-outline-color: var(--lhds-color-red-600)}._navBarNotificationButton_1wt3y_1._unread_1wt3y_23:active{--current-background-color: var(--lhds-color-red-700);--current-outline-color: var(--lhds-color-red-700)}._navBarNotificationButton_1wt3y_1:focus-visible{outline:var(--swui-focus-outline);outline-color:var(--current-outline-color);outline-offset:var(--swui-focus-outline-width)}@keyframes _shake_1wt3y_1{0%{transform:rotate(0)}7%{transform:rotate(20deg)}15%{transform:rotate(-20deg)}22%{transform:rotate(16deg)}30%{transform:rotate(-16deg)}38%{transform:rotate(6deg)}42%{transform:rotate(-6deg)}46%{transform:rotate(2deg)}to{transform:rotate(0)}}._navBarSearchFieldInput_1rp8g_1._navBarSearchFieldInput_1rp8g_1{line-height:2.7rem;color:var(--lhds-color-ui-800)}._navBarSearchFieldInput_1rp8g_1._navBarSearchFieldInput_1rp8g_1::placeholder{color:var(--lhds-color-blue-600)}._navBarSearchFieldInput_1rp8g_1._navBarSearchFieldInput_1rp8g_1{padding:0 var(--swui-metrics-indent)}._navBarSearchFieldWrapper_1rp8g_12._navBarSearchFieldWrapper_1rp8g_12{background:var(--lhds-color-ui-200);border-color:transparent}._navBarSearchFieldWrapper_1rp8g_12._navBarSearchFieldWrapper_1rp8g_12:hover{border-color:transparent}._navBarSearchFieldWrapper_1rp8g_12._navBarSearchFieldWrapper_1rp8g_12{padding:0 var(--swui-metrics-indent);border-radius:var(--swui-max-border-radius)}._navBarSearchFieldWrapper_1rp8g_12._navBarSearchFieldWrapper_1rp8g_12._withButton_1rp8g_24{padding-right:1px}._navBarSearchFieldWrapper_1rp8g_12._navBarSearchFieldWrapper_1rp8g_12:focus-within{color:var(--lhds-color-ui-800);background:var(--lhds-color-ui-50)}._navBarSearchFieldWrapper_1rp8g_12._navBarSearchFieldWrapper_1rp8g_12 ._clearButton_1rp8g_33{border-radius:var(--swui-max-border-radius)}._navBarUserButton_10f9z_1:hover{background:var(--lhds-color-ui-100)}._navBarUserButton_10f9z_1:focus-visible{background:var(--lhds-color-ui-200)}._navBarUserButton_10f9z_1:active{background:var(--lhds-color-ui-200)}._unreadDot_l8bni_1{position:relative}._unreadDot_l8bni_1 ._dot_l8bni_4{top:1px;right:1px;position:absolute;width:8px;height:8px;border-radius:var(--swui-max-border-radius);background:var(--lhds-color-blue-500)}._notification_1hao0_1{display:flex;flex-direction:column;width:100%;background:var(--lhds-color-ui-50)}._notification_1hao0_1 ._body_1hao0_7{padding-left:64px;padding-right:24px;padding-bottom:16px}._notification_1hao0_1._standard_1hao0_13._unread_1hao0_14{background:var(--lhds-color-blue-50)}._notification_1hao0_1._danger_1hao0_19{background:var(--lhds-color-red-100)}._notificationList_1rkvu_1{display:flex;flex-direction:column;gap:2px;background:var(--lhds-color-ui-200)}._clickable_1ijxc_1{--swui-toast-border-color: transparent;--swui-toast-item-border-color-hover: var(--lhds-color-blue-500);--current-border-color: var(--swui-toast-border-color);border-width:1px;border-style:solid;border-color:var(--current-border-color);position:absolute;top:0;left:0;right:0;bottom:0;border-radius:8px;background-color:transparent;width:100%;cursor:pointer}._clickable_1ijxc_1:hover{--current-border-color: var(--swui-toast-item-border-color-hover)}._nonClickable_1ijxc_27{position:relative;z-index:1;pointer-events:none}._nonClickable_1ijxc_27 a,._nonClickable_1ijxc_27 button{pointer-events:auto}._sidebarMenu_1bx5w_1{--swui-sidebar-menu-separator-color: var(--swui-white);--swui-sidebar-menu-text-color: var(--lhds-color-ui-900);--swui-sidebar-menu-icon-color: var(--lhds-color-ui-900);--swui-sidebar-menu-background-color: transparent;--swui-sidebar-menu-background-color-hover: var(--lhds-color-ui-400);--swui-sidebar-menu-background-color-focus: var(--lhds-color-ui-400);--swui-sidebar-menu-background-color-active: var(--lhds-color-ui-300);--swui-sidebar-menu-background-selected: var(--lhds-color-blue-100);--swui-sidebar-menu-background-selected-hover: var(--lhds-color-blue-200);--swui-sidebar-menu-background-selected-focus: var(--lhds-color-blue-200);--swui-sidebar-menu-background-selected-active: var(--lhds-color-blue-100);--current-background-color: var(--swui-sidebar-menu-background-color);--current-background-color-hover: var( --swui-sidebar-menu-background-color-hover );--current-background-color-focus: var( --swui-sidebar-menu-background-color-focus );--current-background-color-active: var( --swui-sidebar-menu-background-color-active );--current-background-selected: var(--swui-sidebar-menu-background-selected);--current-background-selected-hover: var( --swui-sidebar-menu-background-selected-hover );--current-background-selected-focus: var( --swui-sidebar-menu-background-selected-focus );--current-background-selected-active: var( --swui-sidebar-menu-background-selected-active )}._sidebarMenu_1bx5w_1 ._sidebarItems_1bx5w_38{--current-separator-color: var(--swui-sidebar-menu-separator-color);--current-text-color: var(--swui-sidebar-menu-text-color);--current-icon-color: var(--swui-sidebar-menu-icon-color)}._sidebarMenu_1bx5w_1{background-color:var(--current-background-color);height:100dvh}._sidebarMenu_1bx5w_1 ._scrollContainer_1bx5w_48{background:var(--current-background-color);height:100%;overflow:auto}._stenaFlag_108h7_1{height:32px}")),document.head.appendChild(r)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import { jsxs as i, Fragment as B, jsx as n } from "react/jsx-runtime";
import { ActionMenu as V, ActionMenuContext as ln, stenaAngleDown as X, PrimaryButton as cn, SecondaryButton as sn, FlatButton as F, stenaHamburger as J, BaseButton as dn, stenaBellFilled as un, TextInputButton as hn, stenaTimes as pn, stenaUserCircle as gn, CircledIcon as A, CloseButton as K, Icon as mn, stenaMail as fn, MenuButton as $, Card as bn, CardBody as vn, stenaTripFerryXl as _n, Spinner as Bn, StenaFlag as Cn, stenaAngleLeftDouble as Q, stenaPin as xn, IconMenuButton as H, IconMenuButtonLink as yn, MenuButtonLink as kn } from "@stenajs-webui/elements";
import * as wn from "react";
import { useRef as In, useMemo as Nn, forwardRef as Sn, createContext as Mn, useContext as Rn, useState as Fn } from "react";
import { useBoolean as E, Column as h, Box as u, Row as c, Indent as w, Heading as L, Text as f, Space as m, SeparatorLine as Ln } from "@stenajs-webui/core";
import { Popover as j, Tooltip as Y } from "@stenajs-webui/tooltip";
import { Checkbox as Z, TextInput as jn } from "@stenajs-webui/forms";
import p from "classnames";
import { cssColor as b } from "@stenajs-webui/theme";
const U = ({
  renderItems: e,
  placement: t = "bottom",
  buttonComponent: r,
  rightIcon: o = X,
  portalTarget: a = "parent",
  zIndex: l,
  menuWidth: s,
  menuTop: d,
  onClick: g,
  disableArrow: v = !1,
  buttonRef: _,
  ...en
}) => {
  const [T, O, x, tn] = E(!1), rn = In(null), I = _ ?? rn, on = {
    name: "focusManager",
    defaultValue: !0,
    fn({ popper: y }) {
      let N = !1;
      const W = (C) => {
        C.key === "Escape" && (N = !0, x()), (C.key === "Enter" || C.key === " ") && (N = !0);
      };
      return {
        onCreate() {
          y.addEventListener("keydown", W);
        },
        onDestroy() {
          y.removeEventListener("keydown", W);
        },
        onMount() {
          var C;
          N = !1, (C = y.querySelector("button:not([disabled]), a[href]")) == null || C.focus();
        },
        onHide() {
          I.current && N && I.current.focus();
        }
      };
    }
  }, an = Nn(() => ({ open: O, close: x }), [O, x]);
  return /* @__PURE__ */ i(B, { children: [
    /* @__PURE__ */ n(
      r,
      {
        rightIcon: v ? void 0 : o,
        ...en,
        ref: I,
        onClick: (y) => {
          g == null || g(y), tn();
        }
      }
    ),
    /* @__PURE__ */ n(
      j,
      {
        disablePadding: !0,
        visible: T,
        onClickOutside: x,
        placement: t,
        content: T && /* @__PURE__ */ n(V, { width: s, top: d, trapFocus: !0, children: /* @__PURE__ */ n(ln.Provider, { value: an, children: e(x) }) }),
        arrow: !1,
        appendTo: a,
        zIndex: l,
        plugins: [on],
        lazy: !0,
        reference: I
      }
    )
  ] });
}, ze = (e) => /* @__PURE__ */ n(U, { buttonComponent: cn, ...e }), Ae = (e) => /* @__PURE__ */ n(U, { buttonComponent: sn, ...e }), Pn = (e) => /* @__PURE__ */ n(U, { buttonComponent: F, ...e }), zn = "1px solid var(--lhds-color-ui-300)", $e = ({
  renderMenu: e,
  ...t
}) => {
  const [r, o, a] = E(!1);
  return /* @__PURE__ */ n(
    j,
    {
      onClickOutside: a,
      arrow: !1,
      visible: r,
      disablePadding: !0,
      content: e ? /* @__PURE__ */ n(h, { children: /* @__PURE__ */ n(V, { children: e(a) }) }) : void 0,
      placement: "bottom-start",
      children: /* @__PURE__ */ n(u, { display: "inline-block", children: /* @__PURE__ */ i(
        c,
        {
          spacing: 0.5,
          indent: !0,
          alignItems: "center",
          border: zn,
          borderRadius: "4px",
          children: [
            /* @__PURE__ */ n(Z, { ...t }),
            /* @__PURE__ */ n(w, { num: 0.5 }),
            /* @__PURE__ */ n(F, { size: "small", onClick: o, leftIcon: X })
          ]
        }
      ) })
    }
  );
}, An = "_navBar_kzibd_1", $n = {
  navBar: An
}, Hn = ({
  className: e,
  onClick: t
}) => /* @__PURE__ */ n(
  F,
  {
    leftIcon: J,
    className: e,
    onClick: t
  }
), He = ({
  left: e,
  className: t,
  showMenuButton: r = !1,
  children: o,
  right: a,
  center: l,
  onClickMenuButton: s
}) => {
  const d = l ? 1 : void 0;
  return /* @__PURE__ */ i(
    c,
    {
      justifyContent: "space-between",
      className: p($n.navBar, t),
      children: [
        /* @__PURE__ */ i(
          c,
          {
            flex: d,
            justifyContent: "flex-start",
            alignItems: "center",
            children: [
              /* @__PURE__ */ i(c, { width: "86px", alignItems: "center", children: [
                /* @__PURE__ */ n(w, {}),
                r && /* @__PURE__ */ n(Hn, { onClick: s })
              ] }),
              e && /* @__PURE__ */ i(B, { children: [
                e,
                /* @__PURE__ */ n(w, { num: 2 })
              ] }),
              o && /* @__PURE__ */ n(B, { children: /* @__PURE__ */ n(c, { justifyContent: "center", alignItems: "center", children: wn.Children.map(o, (g, v) => /* @__PURE__ */ i(B, { children: [
                v > 0 && /* @__PURE__ */ n(w, {}),
                g
              ] })) }) })
            ]
          }
        ),
        l && /* @__PURE__ */ n(c, { justifyContent: "center", alignItems: "center", children: l }),
        /* @__PURE__ */ i(c, { justifyContent: "flex-end", alignItems: "center", flex: d, children: [
          a,
          /* @__PURE__ */ n(w, { num: 2 })
        ] })
      ]
    }
  );
}, En = "_navBarButton_b3x3w_1", Un = "_selected_b3x3w_14", q = {
  navBarButton: En,
  selected: Un
}, Dn = ({
  selected: e,
  className: t,
  ...r
}) => /* @__PURE__ */ n(
  F,
  {
    ...r,
    className: p(
      q.navBarButton,
      e && q.selected,
      t
    )
  }
), Ee = (e) => /* @__PURE__ */ n(L, { whiteSpace: "nowrap", variant: "h4", as: "h1", ...e }), Ue = ({
  content: e,
  children: t,
  ...r
}) => {
  const [o, , a, l] = E(!1);
  return /* @__PURE__ */ n(
    j,
    {
      onClickOutside: a,
      triggerTarget: document.body,
      visible: o,
      content: /* @__PURE__ */ i(B, { children: [
        e && e({ close: a }),
        t
      ] }),
      children: /* @__PURE__ */ n(Dn, { ...r, onClick: l })
    }
  );
}, Tn = "_navBarNotificationButton_1wt3y_1", On = "_unread_1wt3y_23", Wn = "_icon_1wt3y_23", qn = "_shake_1wt3y_1", k = {
  navBarNotificationButton: Tn,
  unread: On,
  icon: Wn,
  shake: qn
}, De = ({
  count: e,
  unread: t = !1,
  className: r,
  labelClassName: o,
  iconClassName: a,
  icon: l = un,
  ...s
}) => {
  const d = e > 1;
  return /* @__PURE__ */ n(
    dn,
    {
      ...s,
      leftIcon: l,
      className: p(
        k.navBarNotificationButton,
        t && k.unread,
        d && k.hasCount,
        r
      ),
      label: d ? String(e) : void 0,
      labelClassName: p(o, k.label),
      iconClassName: p(a, k.icon)
    }
  );
}, Gn = "_navBarSearchFieldInput_1rp8g_1", Vn = "_navBarSearchFieldWrapper_1rp8g_12", Xn = "_withButton_1rp8g_24", Jn = "_clearButton_1rp8g_33", S = {
  navBarSearchFieldInput: Gn,
  navBarSearchFieldWrapper: Vn,
  withButton: Xn,
  clearButton: Jn
}, Te = ({
  placeholder: e = "Search",
  className: t,
  wrapperClassName: r,
  showClearButton: o,
  onClickClearButton: a,
  value: l,
  ...s
}) => /* @__PURE__ */ n(
  jn,
  {
    wrapperClassName: p(
      S.navBarSearchFieldWrapper,
      o ? S.withButton : void 0,
      r
    ),
    className: p(S.navBarSearchFieldInput, t),
    placeholder: e,
    value: l,
    buttonRight: l && o ? /* @__PURE__ */ n(
      hn,
      {
        className: S.clearButton,
        icon: pn,
        variant: "error",
        onClick: a
      }
    ) : void 0,
    ...s
  }
), Kn = "_navBarUserButton_10f9z_1", Qn = {
  navBarUserButton: Kn
}, Oe = ({
  className: e,
  username: t,
  initials: r,
  icon: o = gn,
  iconClassName: a,
  responsiveIconOnly: l = r == null,
  ...s
}) => /* @__PURE__ */ n(
  Pn,
  {
    ...s,
    className: p(Qn.navBarUserButton, e),
    leftIcon: t != null ? o : void 0,
    label: r ?? t,
    forceRound: r != null,
    responsiveIconOnly: l,
    disableArrow: !0
  }
), Yn = "_unreadDot_l8bni_1", Zn = "_dot_l8bni_4", G = {
  unreadDot: Yn,
  dot: Zn
}, ne = ({ children: e }) => /* @__PURE__ */ i("div", { className: G.unreadDot, children: [
  e,
  /* @__PURE__ */ n("div", { className: G.dot })
] }), nn = ({
  text: e,
  timestamp: t,
  icon: r,
  iconAriaLabel: o,
  contentLeft: a,
  contentRight: l,
  onClose: s,
  unread: d = !1,
  variant: g,
  iconBackgroundColor: v
}) => {
  const _ = r ? /* @__PURE__ */ n(
    A,
    {
      size: "small",
      icon: r,
      "aria-label": o,
      backgroundColor: v || ee(d, g)
    }
  ) : void 0;
  return /* @__PURE__ */ i(c, { alignItems: "flex-start", indent: 2, spacing: !0, children: [
    /* @__PURE__ */ i(c, { spacing: !0, gap: 2, flex: 1, alignItems: "flex-start", children: [
      a && /* @__PURE__ */ n(u, { minHeight: 20, justifyContent: "center", children: a }),
      !a && _ && (d ? /* @__PURE__ */ n(ne, { children: _ }) : _),
      /* @__PURE__ */ i(u, { minHeight: 20, justifyContent: "center", flex: 1, gap: 0.5, children: [
        /* @__PURE__ */ n(f, { variant: "bold", children: e }),
        t && /* @__PURE__ */ n(
          f,
          {
            size: "small",
            color: b(
              d ? "--lhds-color-blue-600" : "--lhds-color-ui-600"
            ),
            children: t
          }
        )
      ] }),
      l
    ] }),
    s && /* @__PURE__ */ n(
      u,
      {
        flex: "none",
        justifyContent: "center",
        height: "calc(20px + 2 * var(--swui-metrics-spacing))",
        children: /* @__PURE__ */ n(K, { onClick: s })
      }
    )
  ] });
}, ee = (e, t) => {
  if (!(!e && t === "standard"))
    return "--lhds-color-ui-50";
}, te = "_notification_1hao0_1", re = "_body_1hao0_7", oe = "_standard_1hao0_13", ie = "_unread_1hao0_14", ae = "_danger_1hao0_19", M = {
  notification: te,
  body: re,
  standard: oe,
  unread: ie,
  danger: ae
}, We = ({
  variant: e = "standard",
  children: t,
  unread: r,
  ...o
}) => /* @__PURE__ */ i(
  "div",
  {
    className: p(
      M.notification,
      M[e],
      r && M.unread
    ),
    children: [
      /* @__PURE__ */ n(nn, { ...o, unread: r, variant: e }),
      t && /* @__PURE__ */ n(h, { className: M.body, children: t })
    ]
  }
), le = "_notificationList_1rkvu_1", ce = {
  notificationList: le
}, qe = ({
  children: e
}) => /* @__PURE__ */ i("div", { className: ce.notificationList, children: [
  e,
  /* @__PURE__ */ n("div", {})
] }), se = "_clickable_1ijxc_1", de = "_nonClickable_1ijxc_27", P = {
  clickable: se,
  nonClickable: de
}, Ge = ({
  onClick: e,
  onClickAriaLabel: t,
  children: r,
  width: o = 264,
  maxWidth: a,
  ...l
}) => /* @__PURE__ */ i(
  u,
  {
    borderRadius: 8,
    background: b("--lhds-color-ui-50"),
    shadow: "popover",
    width: o,
    maxWidth: a,
    role: "alert",
    position: "relative",
    children: [
      /* @__PURE__ */ n(u, { className: p({ [P.nonClickable]: e }), children: /* @__PURE__ */ n(nn, { ...l }) }),
      r && /* @__PURE__ */ i(u, { indent: 3, className: p({ [P.nonClickable]: e }), children: [
        r,
        /* @__PURE__ */ n(m, { num: 2 })
      ] }),
      e && /* @__PURE__ */ n(
        "button",
        {
          onClick: e,
          className: P.clickable,
          "aria-label": t
        }
      )
    ]
  }
), ue = () => /* @__PURE__ */ i(h, { indent: !0, spacing: !0, flex: 1, alignItems: "center", children: [
  /* @__PURE__ */ n(mn, { icon: fn, color: b("--lhds-color-ui-500") }),
  /* @__PURE__ */ n(m, {}),
  /* @__PURE__ */ n(f, { size: "small", color: b("--lhds-color-ui-500"), children: "No content" })
] }), he = Sn(
  function({
    label: t,
    contentLeft: r,
    contentRight: o,
    collapsed: a = !1,
    onClick: l,
    disabled: s = !1,
    children: d,
    autoFocus: g = !1,
    ...v
  }, _) {
    return /* @__PURE__ */ n(
      $,
      {
        ...v,
        autoFocus: g,
        ref: _,
        label: t,
        onClick: l,
        disabled: s,
        expandable: !0,
        expanded: !a,
        selected: !a,
        left: r,
        right: o,
        children: d ?? /* @__PURE__ */ n(ue, {})
      }
    );
  }
), Ve = ({
  children: e
}) => /* @__PURE__ */ n(h, { gap: 1, children: e }), Xe = ({
  value: e,
  onValueChange: t,
  onChange: r,
  indeterminate: o,
  checkboxDisabled: a,
  ...l
}) => /* @__PURE__ */ n(
  he,
  {
    contentLeft: /* @__PURE__ */ n(
      Z,
      {
        value: e,
        indeterminate: o,
        onValueChange: t,
        onChange: r,
        disabled: a,
        onClick: (s) => s.stopPropagation()
      }
    ),
    ...l
  }
), Je = ({ children: e }) => /* @__PURE__ */ n(u, { spacing: !0, indent: !0, children: /* @__PURE__ */ n(f, { variant: "overline", size: "smaller", children: e }) }), pe = ({
  text: e,
  heading: t,
  children: r,
  buttons: o,
  icon: a = _n,
  headingLevel: l = "h3",
  ...s
}) => {
  const d = !e && !t ? "Something unexpected happened." : e;
  return /* @__PURE__ */ n(bn, { ...s, children: /* @__PURE__ */ n(vn, { children: /* @__PURE__ */ i(h, { spacing: 1, gap: 3, alignItems: "center", children: [
    /* @__PURE__ */ i(h, { alignItems: "center", children: [
      /* @__PURE__ */ n(m, { num: 1 }),
      /* @__PURE__ */ n(A, { icon: a, size: "xl" })
    ] }),
    t && /* @__PURE__ */ n(L, { as: l, children: t }),
    d && /* @__PURE__ */ n(f, { children: d }),
    r,
    o && /* @__PURE__ */ i(u, { children: [
      /* @__PURE__ */ n(m, { num: 2 }),
      o
    ] })
  ] }) }) });
}, Ke = (e) => /* @__PURE__ */ n(
  u,
  {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    children: /* @__PURE__ */ n(pe, { ...e })
  }
), ge = ({
  text: e = "Loading..."
}) => /* @__PURE__ */ i(u, { alignItems: "center", children: [
  /* @__PURE__ */ n(Bn, { size: "small" }),
  /* @__PURE__ */ n(m, { num: 4 }),
  /* @__PURE__ */ n(L, { variant: "h4", children: e })
] }), Qe = (e) => /* @__PURE__ */ n(
  u,
  {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    children: /* @__PURE__ */ n(ge, { ...e })
  }
), Ye = ({
  renderBreadCrumbs: e,
  renderPageHeading: t,
  renderTabs: r,
  children: o
}) => /* @__PURE__ */ i(u, { shadow: "bottom", background: b("--lhds-color-ui-50"), gap: 2, children: [
  /* @__PURE__ */ i(u, { indent: 3, children: [
    e && /* @__PURE__ */ i(c, { spacing: 1, alignItems: "center", children: [
      /* @__PURE__ */ n(c, { width: "64px", height: "16px" }),
      e()
    ] }),
    t == null ? void 0 : t(),
    r && /* @__PURE__ */ n(m, {}),
    r == null ? void 0 : r()
  ] }),
  o
] }), Ze = (e) => /* @__PURE__ */ n(c, { indent: 3, spacing: !0, ...e }), nt = ({
  icon: e,
  heading: t,
  headingLevel: r = "h2",
  contentLeft: o,
  contentRight: a
}) => /* @__PURE__ */ i(c, { alignItems: "center", gap: 2, height: "64px", children: [
  /* @__PURE__ */ i(c, { alignItems: "center", children: [
    /* @__PURE__ */ n(c, { width: "64px", alignItems: "center", children: e && /* @__PURE__ */ n(A, { icon: e }) }),
    /* @__PURE__ */ n(L, { variant: "h3", as: r, children: t })
  ] }),
  /* @__PURE__ */ n(c, { alignItems: "center", children: o }),
  /* @__PURE__ */ n(c, { style: { marginLeft: "auto" }, alignItems: "center", children: a })
] }), me = "_sidebarMenu_1bx5w_1", fe = "_sidebarItems_1bx5w_38", be = "_scrollContainer_1bx5w_48", z = {
  sidebarMenu: me,
  sidebarItems: fe,
  scrollContainer: be
}, ve = "_stenaFlag_108h7_1", _e = {
  stenaFlag: ve
}, Be = ({ onClick: e }) => /* @__PURE__ */ i(h, { background: b("--lhds-color-ui-50"), children: [
  /* @__PURE__ */ n(m, {}),
  /* @__PURE__ */ i(
    c,
    {
      justifyContent: "space-between",
      alignItems: "center",
      flex: 1,
      indent: 1,
      minHeight: "48px",
      children: [
        /* @__PURE__ */ n(K, { onClick: e }),
        /* @__PURE__ */ n(Cn, { className: _e.stenaFlag })
      ]
    }
  )
] }), Ce = ({
  isPinned: e,
  onClick: t,
  label: r
}) => /* @__PURE__ */ n($, { onClick: t, label: r ?? (e ? "Unpin menu" : "Pin menu"), leftIcon: e ? Q : xn }), et = ({
  className: e,
  children: t,
  onCloseClick: r,
  variant: o = "standard",
  pinButtonVisible: a,
  onClickPinButton: l,
  bottomItems: s,
  isPinned: d,
  ...g
}) => /* @__PURE__ */ i(u, { ...g, className: p(z.sidebarMenu, e), children: [
  /* @__PURE__ */ n(Be, { onClick: r }),
  /* @__PURE__ */ n(u, { className: z.scrollContainer, children: /* @__PURE__ */ i(
    h,
    {
      className: z.sidebarItems,
      justifyContent: "space-between",
      flex: 1,
      gap: 1,
      indent: 1,
      children: [
        /* @__PURE__ */ n(h, { gap: 1, children: t }),
        (s || a) && /* @__PURE__ */ i(h, { gap: 1, children: [
          s,
          a && /* @__PURE__ */ n(
            Ce,
            {
              isPinned: d,
              onClick: l
            }
          ),
          /* @__PURE__ */ n(m, {})
        ] })
      ]
    }
  ) })
] }), R = Mn(!1), D = () => Rn(R), xe = ({
  label: e,
  ...t
}) => /* @__PURE__ */ n(Y, { label: e, placement: "right", appendTo: document.body, children: /* @__PURE__ */ n(H, { ...t }) }), tt = ({
  closeButtonVisible: e,
  onClickCloseButton: t,
  onClickMenuButton: r,
  children: o,
  bottomItems: a,
  closeButtonTitle: l = "Unpin menu"
}) => /* @__PURE__ */ i(
  u,
  {
    position: "fixed",
    left: 0,
    top: 0,
    bottom: 0,
    indent: 0.5,
    spacing: 1,
    gap: 1,
    shadow: "popover",
    background: b("--lhds-color-ui-50"),
    children: [
      /* @__PURE__ */ n(H, { onClick: r, icon: J }),
      /* @__PURE__ */ i(h, { justifyContent: "space-between", flex: 1, gap: 1, children: [
        /* @__PURE__ */ n(h, { gap: 1, children: /* @__PURE__ */ n(R.Provider, { value: !0, children: o }) }),
        /* @__PURE__ */ n(h, { gap: 1, children: (a || e) && /* @__PURE__ */ i(R.Provider, { value: !0, children: [
          a,
          e && /* @__PURE__ */ n(
            xe,
            {
              icon: Q,
              label: l,
              onClick: t
            }
          )
        ] }) })
      ] })
    ]
  }
), ye = ({
  label: e
}) => D() ? null : /* @__PURE__ */ i(u, { height: "32px", justifyContent: "center", indent: 1, children: [
  /* @__PURE__ */ n(m, {}),
  /* @__PURE__ */ n(f, { variant: "overline", size: "smaller", children: e })
] }), ke = ({
  label: e,
  leftIcon: t,
  ...r
}) => t == null ? null : /* @__PURE__ */ n(Y, { label: e, placement: "right", appendTo: document.body, children: /* @__PURE__ */ n(yn, { icon: t, ...r }) }), rt = (e) => D() ? /* @__PURE__ */ n(ke, { ...e }) : /* @__PURE__ */ n(kn, { ...e }), we = ({
  children: e,
  label: t,
  icon: r,
  popupMinWidth: o = "200px"
}) => /* @__PURE__ */ n(
  j,
  {
    appendTo: "parent",
    arrow: !1,
    offset: [0, 0],
    placement: "right-start",
    trigger: "focusin mouseenter click",
    disablePadding: !0,
    lazy: !0,
    content: /* @__PURE__ */ n(
      u,
      {
        minWidth: o,
        shadow: "popover",
        spacing: 1,
        indent: 1,
        gap: 2,
        children: /* @__PURE__ */ i(R.Provider, { value: !1, children: [
          /* @__PURE__ */ n(ye, { label: t }),
          e
        ] })
      }
    ),
    children: /* @__PURE__ */ n(H, { icon: r })
  }
), ot = ({
  children: e,
  label: t,
  leftIcon: r,
  className: o,
  initialExpand: a = !1
}) => {
  const [l, s] = Fn(a);
  return D() ? r == null ? null : /* @__PURE__ */ n(we, { label: t, icon: r, children: e }) : /* @__PURE__ */ n(
    $,
    {
      label: t,
      onClick: () => s(!l),
      leftIcon: r,
      className: o,
      expandable: !0,
      expanded: l,
      selected: l,
      children: e
    }
  );
}, it = (e) => /* @__PURE__ */ n(
  Ln,
  {
    color: b("--lhds-color-ui-400"),
    ...e
  }
), at = ({ numItemsSelected: e, label: t, afterLabelContent: r, rightContent: o }) => /* @__PURE__ */ i(
  c,
  {
    indent: 3,
    spacing: !0,
    gap: 3,
    minHeight: "56px",
    justifyContent: "space-between",
    alignItems: "center",
    background: b("--silver-lighter"),
    flex: 1,
    borderRadius: "var(--swui-border-radius)",
    children: [
      /* @__PURE__ */ i(c, { alignItems: "center", gap: 2, children: [
        e != null || t != null ? /* @__PURE__ */ n(c, { alignItems: "center", children: e != null ? /* @__PURE__ */ i(B, { children: [
          /* @__PURE__ */ n(f, { children: e }),
          /* @__PURE__ */ n(m, {}),
          /* @__PURE__ */ i(f, { children: [
            "item",
            e === 1 ? "" : "s",
            " selected"
          ] })
        ] }) : t != null ? /* @__PURE__ */ n(B, { children: typeof t == "string" ? /* @__PURE__ */ n(f, { children: t }) : t }) : null }) : null,
        r && /* @__PURE__ */ n(c, { children: r })
      ] }),
      /* @__PURE__ */ n(c, { gap: 2, children: o })
    ]
  }
), lt = ({ children: e }) => /* @__PURE__ */ n(c, { spacing: 0.5, indent: 0.5, flex: 1, children: e });
export {
  Pn as ActionMenuFlatButton,
  ze as ActionMenuPrimaryButton,
  Ae as ActionMenuSecondaryButton,
  $e as CheckboxMenu,
  he as Collapsible,
  ue as CollapsibleEmptyContent,
  Je as CollapsibleGroupHeading,
  Ve as CollapsibleList,
  Xe as CollapsibleWithCheckbox,
  pe as ErrorPanel,
  Ke as ErrorScreen,
  ge as LoadingPanel,
  Qe as LoadingScreen,
  He as NavBar,
  Dn as NavBarButton,
  Ee as NavBarHeading,
  De as NavBarNotificationButton,
  Ue as NavBarPopoverButton,
  Te as NavBarSearchField,
  Oe as NavBarUserButton,
  We as Notification,
  nn as NotificationHeader,
  qe as NotificationList,
  Ye as PageHeader,
  Ze as PageHeaderRow,
  nt as PageHeading,
  lt as SelectedItemsActionsPadding,
  at as SelectedItemsActionsPanel,
  et as SidebarMenu,
  ot as SidebarMenuCollapsible,
  ye as SidebarMenuHeading,
  rt as SidebarMenuLink,
  it as SidebarMenuSeparator,
  tt as SidebarRailMenu,
  Ge as Toast,
  ne as UnreadDot,
  ee as getIconBgColorFromVariant
};
//# sourceMappingURL=index.es.js.map
